import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './module/user'
import tag from './module/tag'

Vue.use(Vuex)

export default new Vuex.Store({
  state() {
    return {
    }
  },
  getters,
  mutations: {
  },
  modules: {
    user,
    tag
  }
})
